import { getStoredAccessToken, getStoredSsoConfig } from 'utils/localStorage';

export default function hasSsoToken(): boolean {
  const token = getStoredAccessToken();
  if (token) {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.iss && payload.iss !== window.location.origin) {
      return true;
    }
  }
  return false;
}
